<form [formGroup]="form">
  <div
    class="header h-[55px] flex justify-start items-center pl-[50px] mb-[9px] !bg-[#F1F3F5] overflow-y-hidden sticky !z-20 top-0"
  >
    <p class="!m-0 text-[18px]">
      {{ projectName }} - Initiate Expression Of Interest
    </p>
    <p
      class="!mt-[10px] bg-white !ml-[15px] flex items-center justify-center tag"
    >
      Eligibility & Submission Guideline
    </p>
  </div>
  <span class="font-medium text-[1.125rem] pl-[49px]"
    >Eligibility Criteria</span
  >
  <div class="!ml-[50px] !mr-[66px] mt-[6px]" style="margin-right: 66px">
    <app-rich-textEditor
      class="!w-[100px]"
      (contentChange)="eligibilityCriteria($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('eligibilityCriteria')?.value"
      [placeHolder]="'Eligibility Criteria...'"
    >
    </app-rich-textEditor>
    <mat-error *ngIf="form.get('eligibilityCriteria').invalid && form.get('eligibilityCriteria').touched">
      Eligibility Criteria is required 
    </mat-error>
  </div>
  <div class="mt-[2rem]">
  <label class=" mt-[6px] font-medium text-[1.125rem] pl-[49px]">Submission Guideline</label>
  <div
    class="!pl-[50px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8 mt-[10px]"
  >
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label> Issue of EOI </mat-label>
          <input
            matInput
            [matDatepicker]="picker"
            formControlName="issueOfEOI"
            placeholder="Issue of EOI"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker startView="year"></mat-datepicker>
          <mat-error *ngIf="form.get('issueOfEOI').invalid && form.get('issueOfEOI').touched">
            EOI issue date is required
          </mat-error>
        </mat-form-field>
        
      </div>
    </div>

    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label> EOI Submission Closing </mat-label>
          <input
            matInput
            [matDatepicker]="eoiSubmissionClosing"
            formControlName="eoiSubmissionClosing"
            placeholder="EOI Submission Closing"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="eoiSubmissionClosing"
          ></mat-datepicker-toggle>
          <mat-datepicker
            #eoiSubmissionClosing
            startView="year"
          ></mat-datepicker>
          <mat-error *ngIf="
          form.get('eoiSubmissionClosing').invalid &&
          form.get('eoiSubmissionClosing').touched
        " >
      EOI Submission Closing is required  
      </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label> EOI Inquiry Deadline </mat-label>
          <input
            matInput
            [matDatepicker]="eoiInquiryDeadline"
            formControlName="eoiInquiryDeadline"
            placeholder="EOI Inquiry Deadline"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="eoiInquiryDeadline"
          ></mat-datepicker-toggle>
          <mat-datepicker #eoiInquiryDeadline startView="year"></mat-datepicker>
          <mat-error *ngIf="
          form.get('eoiInquiryDeadline').invalid &&
          form.get('eoiInquiryDeadline').touched
        " >
      EOI Deadline is required  
      </mat-error>
        </mat-form-field>
       
      </div>
    </div>

    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label> Float EPC Tender </mat-label>
          <input
            matInput
            [matDatepicker]="floatEPCTender"
            formControlName="floatEPCTender"
            placeholder="Float EPC Tender"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="floatEPCTender"
          ></mat-datepicker-toggle>
          <mat-datepicker #floatEPCTender startView="year"></mat-datepicker>
          <mat-error *ngIf="
          form.get('floatEPCTender').invalid &&
          form.get('floatEPCTender').touched
        " >
      Float EPC Tender is required 
      </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
  <div
    class="!pr-[66px] !mb-[30px] !mt-[49px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
  >
    <div class="!w-[100%] flex justify-end items-center">
      <button (click)="handleBack()" type="button" class="back-btn">
        Back
      </button>
      <button
        class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
        (click)="moveToNextStep()"
      >
        Next
      </button>
    </div>
  </div>
</form>
